import { j as n } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
function t({
  children: i
}) {
  return /* @__PURE__ */ n("div", {
    css: {
      display: "flex",
      flexDirection: "column",
      paddingTop: "var(--ion-safe-area-top, 0px)",
      width: "100%",
      position: "sticky",
      top: 0,
      zIndex: 6
    },
    children: i
  });
}
export {
  t as BannerContainer
};
